import Vue from 'vue'
import './registerServiceWorker'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '../src/assets/custom-vars.scss'
import { store } from './store'
import App from './App.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faHotTub, faWifi, faFish, faDog, faWheelchair, faCalendarAlt, faSitemap, faClock, faUsers, faUmbrellaBeach } from '@fortawesome/free-solid-svg-icons'
// import { faCalendar } from '@fortawesome/free-regular-svg-icons'
// import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueLodash from 'vue-lodash'
// import Searchwidget from './components/SearchWidget.vue'
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate) 



Vue.use(BootstrapVue);
library.add(faHotTub, faWifi, faFish, faDog, faWheelchair, faCalendarAlt, faSitemap, faClock, faUsers, faUmbrellaBeach)

Vue.use(require('vue-moment'));

Vue.use(VueLodash)

Vue.component('font-awesome-icon', FontAwesomeIcon)


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#vue-search-widget')
